import $ from 'jquery';

//import Common from '../common/base/common';
import CommonCustom from './base/common';
import Layout from './base/layout';

// Shared Components
import './components/banner';
import '../common/components/webpimages';
import '../common/components/lazyload';
import './components/formbuilder';

$(() => {
    const commonCustom = new CommonCustom();
    commonCustom.init();

	const layout = new Layout();
    layout.init();
});
